import apiFetch from '../apiFetch'

export default function (token, filter, documentTypeId) {
  return apiFetch({ endPoint: `DocumentType/${documentTypeId}/Metadatas`, method: 'POST', body: filter, token: token })
}
